// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Form from '@cloudscape-design/components/form';
import FormField from '@cloudscape-design/components/form-field';
import Header from '@cloudscape-design/components/header';
import Input from '@cloudscape-design/components/input';
import React, { useEffect, useRef, useState } from 'react';
const _preserve = React.version;


import { Box, ContentLayout, Grid, Link, RadioGroup, StatusIndicator } from '@cloudscape-design/components';
import SpaceBetween from '@cloudscape-design/components/space-between';

import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js';
import Icon from '@mdi/react';
import PhoneInput from '../../../../components/PhoneInput';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import {
  base64Encode,
  getCookie,
  getUrlVersion,
  isMobileDevice,
  isValidPhone,
  setPhone
} from '../../../commons/functions'; // Import the function
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useRouter } from '../../router';


export const UserRestorePage = () => {
  const { idUser, data, menu, phone } = useGlobalState();
  React.version;
  const { navigate } = useRouter();
  const movilRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  const [btnLoading, setBtnLoading] = useState(false);
  const [status, setStatus] = useState<any>();
  const [error, setError] = useState({ error: "", errorType: "" });


  const handleCloseSendRestore = async () => {
    try {
      setBtnLoading(true);
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/login/reset.password',
          // 
        },
        body: JSON.stringify({
          phone1: phone,
          code: status.code,
          pwd: base64Encode(status.pwd1)
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data.code == 0) {
        setStatus({ ...status, step: 5 });
        setError({ error: "Contraseña ha sido actualizada", errorType: "success" });
      } else {
        setError({ error: data.status, errorType: "error" });
      }
    } catch (error: any) {
      setError({ error: `Error de red y/o comunicaciones2: ${error.message}`, errorType: "error" });
    } finally {
      setBtnLoading(false);
    }
  }
  const recoveryMethods = [
    { value: "WHATSAPP", label: "WhatsApp", description: "Enviar su número primario de teléfono registrado en CPV" },
    { value: "EMAIL", label: "Email", description: "A sus correos registrados en el sistema CPV" },
  ]
  const handlePhone = async () => {
    //setStatus({ ...status, pwdShow: false })
    setBtnLoading(true);
    clearErrors();
    try {

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/login/phone',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          phone: status.phone,
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setStatus({ ...status, step: 2, pwdShow: false, code: "" });
      } else {
        setError({ error: dataWeb.status, errorType: "error" });
      }
    } catch (error: any) {
      setError({ error: error.message, errorType: "error" });
    } finally {
      setBtnLoading(false);
    }
  }
  const handleRequestCode = async () => {
    setBtnLoading(true);
    clearErrors();
    try {


      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/login/request.code',
          // 
        },
        body: JSON.stringify({
          phone1: status.phone,
          type: status.recoveryMethod,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setStatus({ ...status, step: 3, pwdShow: false, code: "" });
      } else {
        setError({ error: dataWeb.status, errorType: "error" });
      }
    } catch (error: any) {
      setError({ error: error.message, errorType: "error" });
    } finally {
      setBtnLoading(false);
    }
  }
  const handleValidateCode = async () => {
    setBtnLoading(true);
    clearErrors();
    try {

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/login/validate.code',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          phone: status.phone,
          code: status?.code,
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);

      }
      const data = await response.json();
      if (data.code == 0) {
        setStatus({ ...status, step: 4, pwd1: "", pwd2: "", showPwd1: false, showPwd2: false });
      } else {
        setError({ error: data.status, errorType: "error" });
      }
    } catch (error: any) {
      setError({ error: `Error de red y/o comunicaciones2: ${error.message}`, errorType: "error" });
    } finally {
      setBtnLoading(false);
    }
  }
  const handleUpdatePassword = async () => {
    setBtnLoading(true);
    try {
      setBtnLoading(true);
      const response = await fetch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/public/login/reset.password',
          // 
        },
        body: JSON.stringify({
          phone1: phone,
          code: status.code,
          pwd: base64Encode(status.pwd1)
        }),
        //mode: 'no-cors'  // Bypasses CORS but limits the response
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data.code == 0) {
        setStatus({ ...status, step: 5 });
        setError({ error: "Contraseña ha sido actualizada", errorType: "success" });
      } else {
        setError({ error: data.status, errorType: "error" });
      }
    } catch (error: any) {
      setError({ error: `Error de red y/o comunicaciones2: ${error.message}`, errorType: "error" });
    } finally {
      setBtnLoading(false);
    }
  }

  useEffect(() => {
    setStatus({ step: 1, phone: phone, pwd1: "", pwd2: "", code: "", showPwd1: false, showPwd2: false, validation: [], recoveryMethod: "", loading: false })
  }, []);
  const clearErrors = () => {
    setError({ error: "", errorType: "" });
  };

  const validatePassword = (passwordToCheck: string) => {
    const newErrors: string[] = [];
    if (passwordToCheck.length === 0) {
      setStatus({ ...status, validation: newErrors });
      return;
    }
    if (passwordToCheck.length < 8) {
      newErrors.push('Al menos 8 caracteres');
    }

    if (!/[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?]/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos un símbolo (ej: # $ . ?)');
    }
    if (!/(?=.*[a-z])/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos una letra minúscula');
    }
    if (!/(?=.*[A-Z])/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos una letra mayúscula');
    }
    if (!/(?=.*\d)/.test(passwordToCheck)) {
      newErrors.push('Debe incluir al menos un número');
    }
    if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#\$%\^&\*\(\)\-\+\=\[\]\{\}\\\|\;\:\'\"\,\<\>\.\/\?])/.test(passwordToCheck)) {
      //   newErrors.push('Debe incluir una mezcla de letras mayúsculas y minúsculas, números y símbolos');
    }

    setStatus({ ...status, validation: newErrors });
  }

  useEffect(() => {
    if (status && status.step === 4) {
      validatePassword(status.pwd1);
    }
  }, [status?.pwd1]);
  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      backgroundImage: `url("resources/portal.${isMobileDevice() ? "M" : "D"}.jpg")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    }}>
      <Form><div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
      }}>
        <div style={{
        }}>
          <ContentLayout
            defaultPadding
            disableOverlap
            headerBackgroundStyle={mode =>
              `transparent`
            }
            header={
              <Box padding={{ vertical: "xxxl" }}>
                <Grid
                  gridDefinition={[
                    { colspan: { default: 12, s: 8 } }
                  ]}
                >
                  <Container
                  >
                    <Box padding="s">
                      <Box
                        fontSize="display-l"
                        fontWeight="bold"
                        variant="h1"
                        padding="n"
                      >
                        CPV
                      </Box>
                      <Box
                        fontSize="display-l"
                        fontWeight="light"
                      >
                        IntraNET Socios
                      </Box>
                      <Box
                        variant="p"
                        color="text-body-secondary"
                        margin={{ top: "xs", bottom: "l" }}
                      >
                        Club de Planeadores de Vitacura
                      </Box>
                      <SpaceBetween size="l">

                        {!!status && (

                          <div style={{ width: "100%", alignItems: "center", display: "flex", justifyContent: "center" }}>
                            <div style={{ minWidth: "300px", maxWidth: '400px' }}>
                              {/*<Button onClick={() => console.log(status)}>Status</Button>*/}
                              <Container header={<Header variant="h2"

                              >Restaurar contraseña</Header>}>
                                {error.error !== "" && (
                                  <StatusIndicator type={error.errorType as "error" | "success" | "warning"}>{error.error}
                                    <Link onClick={() => clearErrors()}><Icon path={mdiClose} size={1} /></Link>
                                  </StatusIndicator>
                                )}
                                <Form
                                  actions={
                                    status?.step < 5 && (
                                      <Button onClick={status?.step === 1 ? handlePhone :
                                        status?.step === 2 ? handleRequestCode : status?.step === 3 ? handleValidateCode : handleUpdatePassword}
                                        loading={btnLoading}
                                        disabled={
                                          (status?.step === 1 && !isValidPhone(status.phone))

                                          || (status?.step === 2 && status.recoveryMethod === "")
                                          || (status?.step === 3 && status.code.length < 4)
                                          || (status?.step === 4 &&
                                            (status.pwd1 !== status.pwd2 ||
                                              status.pwd1.length === 0 ||
                                              (status.pwd1.length > 0 && status.validation.length > 0))
                                          )
                                        } variant="primary">{
                                          status.step <= 3 ? "Siguiente" : "Restaurar"}</Button>
                                    )
                                  }
                                  secondaryActions={
                                    status?.step > 0 && (
                                      <Button variant="link" onClick={() => {
                                        clearErrors();
                                        console.log(status)
                                        if (status.step === 1) {
                                          window.location.hash = "#user/login";
                                        }
                                        else if (status.step === 2) {

                                          setStatus({
                                            ...status,
                                            pwd1: "",
                                            pwd2: "",
                                            showPwd1: false,
                                            showPwd2: false,
                                            recoveryMethod: "",
                                            step: 1
                                          })
                                        }
                                        else if (status.step === 3) {
                                          console.log("Back to 2")
                                          setStatus({
                                            ...status,
                                            pwd1: "",
                                            pwd2: "",
                                            showPwd1: false,
                                            showPwd2: false,
                                            recoveryMethod: "",
                                            code: "",
                                            step: 2
                                          })
                                        }

                                        else if (status.step === 4) {
                                          setStatus({
                                            ...status,
                                            pwd1: "",
                                            pwd2: "",
                                            showPwd1: false,
                                            showPwd2: false,
                                            code: "",
                                            step: 3
                                          })
                                        }
                                      }}>{status.step === 1 ? "Cancelar" : "Atrás"}</Button>
                                    )}>
                                  {status.step === 1 && (

                                    <FormField
                                      label="Teléfono"
                                      constraintText="Teléfono primario registrado en CPV">
                                      <PhoneInput value={phone.toString()}
                                        onChange={(phone) => {
                                          setPhone(phone)
                                          setStatus({ ...status, phone: phone })
                                        }}
                                        ref={movilRef}

                                      />
                                    </FormField>
                                  )}
                                  {status.step === 2 && (

                                    isValidPhone(status.phone) && (
                                      <FormField
                                        label="Recibir el código vía">
                                        <RadioGroup
                                          value={status.recoveryMethod}
                                          onChange={({ detail }) =>
                                            setStatus({ ...status, recoveryMethod: detail.value })
                                          }
                                          items={recoveryMethods}
                                        />
                                      </FormField>
                                    )
                                  )}

                                  {status.step === 3 && (

                                    <FormField
                                      label="Código de verificación">

                                      <Input
                                        type={"number"}
                                        autoComplete="off"
                                        value={status.code}
                                        onChange={({ detail }) => {
                                          if (detail.value.length > 4) return;
                                          setStatus({ ...status, code: detail.value })
                                        }}
                                      />
                                    </FormField>

                                  )}

                                  {status.step === 5 && (
                                    <SpaceBetween direction="vertical" size="l">
                                      <Box textAlign="center">
                                        <Button variant="primary" onClick={() => window.location.hash = '#user/login'}>
                                          Inicar sesión
                                        </Button>
                                      </Box>

                                    </SpaceBetween>
                                  )}
                                  {status.step === 4 && (
                                    <SpaceBetween direction="vertical" size="l">
                                      <FormField
                                        label="Nueva contraseña"
                                        constraintText={status.validation?.join(', ')}
                                        info={
                                          <Link onClick={() => setStatus({ ...status, pwdShow1: !status.pwdShow1 })}>
                                            {status.pwdShow1 ? <Icon path={mdiEyeOutline} size={0.75} /> : <Icon path={mdiEyeOffOutline} size={0.75} />}
                                          </Link>
                                        }
                                      >
                                        <Input
                                          value={status?.pwd1 || ''}
                                          onChange={(e) => setStatus({ ...status, pwd1: e.detail.value })}
                                          autoComplete="off"
                                          type={status.pwdShow1 ? 'text' : 'password'}

                                        />
                                      </FormField>

                                      <FormField
                                        label="Confirmación"
                                        info={
                                          <Link onClick={() => setStatus({ ...status, pwdShow2: !status.pwdShow2 })}>
                                            {status.pwdShow2 ? <Icon path={mdiEyeOutline} size={0.75} /> : <Icon path={mdiEyeOffOutline} size={0.75} />}
                                          </Link>
                                        }
                                      >
                                        <Input
                                          value={status?.pwd2 || ''}
                                          onChange={(e) => setStatus({ ...status, pwd2: e.detail.value })}
                                          autoComplete="off"
                                          type={status.pwdShow2 ? 'text' : 'password'}

                                        />
                                      </FormField>
                                    </SpaceBetween>
                                  )}
                                </Form>
                              </Container>
                            </div>
                          </div>
                        )}

                      </SpaceBetween>
                    </Box>
                  </Container>
                </Grid>
              </Box>
            }
          />
        </div>

      </div>

      </Form >
    </div >



  );
};
